import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  children: React.ReactNode;
}

function ReturnContainer({ children }: Props) {
  return (
    <div
      id="return-container"
      className={cn(
        "flex flex-col p-8 sm:pb-4 bg-white w-full",
        "sm:w-auto h-full sm:h-auto sm:max-h-[95vh]",
        "sm:min-h-96 border border-[rgb(235,235,235)] overflow-y-scroll sm:overflow-y-auto",
        "text-black"
      )}
    >
      {children}
    </div>
  );
}

export { ReturnContainer };
